export default async function GetTaskHeatmapApi(perfCycleId, positionId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/heatmap?perfCycleId=${perfCycleId}&positionId=${positionId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error fetching heatmap: ", error);
        res = { success: false, data: [], message: "Error fetching heatmap" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, data: [], message: "Error fetching heatmap" };
  }

  return res;
}
